import * as React from 'react';
import cx from 'classnames';

import { Popover } from 'src/widgets/Popover';
import { Select } from 'src/widgets/Select';

import options, { optionsToSymbols } from './options';
import { SingleValue, ValueRange } from './SingleValuePicker';
import { monetaryReducer } from './monetaryReducer';

import styles from '../Filters.scss';
const { useRef, useState } = React;

export const paymentReducer = monetaryReducer('PAYMENT', 'payment');

const OptionsToComponent = (option, setFilters, values) => {
  if (
    option === 'greaterThan' ||
    option === 'lessThan' ||
    option === 'equalTo'
  ) {
    return (
      <SingleValue
        setFilters={setFilters}
        values={values}
        filterName="PAYMENT"
      />
    );
  }
  if (option === 'isBetween') {
    return (
      <ValueRange
        setFilters={setFilters}
        values={values}
        filterName="PAYMENT"
      />
    );
  }
};

export const PaymentFilter = ({ filters, setFilters, removeFilter, isDisabled }) => {
  const [open, setOpen] = useState(true);
  const paymentState = filters.payment;
  const option = paymentState.option;
  const ref = useRef<HTMLDivElement>(null);
  return (
    <>
      <div
        ref={ref}
        className={cx(styles.filter, {
          [styles.disabled]: isDisabled,
        })}
        onClick={() => !isDisabled && setOpen(true)}
      >
        <span className={styles.filterCircle}>
          {optionsToSymbols[option.label]}
        </span>
        <span className={styles.filterText}>Payment</span>
        <span
          className={cx(styles.filterCircle, styles.right)}
          onClick={() => !isDisabled && removeFilter('payment')}
        >
          ×
        </span>
      </div>
      <Popover
        mountRef={ref}
        show={open}
        onRequestClose={() => setOpen(false)}
        className={styles.DateFilterPopover}
      >
        <Select
          hintText="Select Comparison..."
          options={options}
          selectedIndex={option.index}
          onChange={(option, index) =>
            setFilters({
              type: 'CHOOSE_PAYMENT_FILTER_COMPARISON',
              payload: { label: option, index },
            })
          }
        />
        {OptionsToComponent(option.label, setFilters, paymentState)}
      </Popover>
    </>
  );
};
